/* eslint-disable class-methods-use-this */
import ReactGA from 'react-ga';

const DIMENSIONS = {
  'User Type': 'dimension2',
  'User Status': 'dimension3',
};

export const CONTENT_GROUPS: Record<string, any> = {
  default: 'contentGroup4',
};

export const ECOMMERCE_REVENUE = {
  clickOff: '0.98',
  lead: '5.50',
};

export interface EventProps {
  hitType?: string;
  category?: string;
  action?: string;
  label?: string | number[];
  value?: string;
  nonInteraction?: boolean;
  location?: string;
}

export function event({
  hitType = 'event',
  category: eventCategory,
  action: eventAction,
  label: eventLabel,
  value: eventValue,
  nonInteraction = true,
  location = '',
}: EventProps): void {
  const eventParams = {
    hitType,
    eventCategory,
    eventAction,
    eventLabel,
    eventValue,
    nonInteraction,
  };
  if (location) {
    ReactGA.ga('set', 'location', location);
  }
  ReactGA.ga('send', eventParams);
}

class GoogleAnalytics {
  constructor() {
    if (typeof window === 'undefined') {
      return;
    }

    ReactGA.initialize('UA-31147538-1');
    ReactGA.ga('require', 'displayfeatures');
    ReactGA.ga('require', 'ecommerce');
  }

  pageView(): void {
    ReactGA.ga('set', 'location', window.location.pathname);
    ReactGA.ga('send', 'pageview');
  }

  ecommerce({
    id,
    revenue,
    location,
  }: {
    id: number | string;
    revenue: string;
    location: string;
  }): void {
    ReactGA.ga('set', 'location', location);
    ReactGA.ga('ecommerce:addTransaction', { id, revenue });
    ReactGA.ga('ecommerce:send');
  }

  event(...args: Parameters<typeof event>): ReturnType<typeof event> {
    return event(...args);
  }
}
export interface ContentGroups {
  default?: string | null | undefined;
  [key: string]: string | null | undefined;
}

export function setDimensionsUserStatus(isSignedIn = false): void {
  const userStatus = isSignedIn ? 'logged_in' : 'not_logged_in';
  ReactGA.ga('set', DIMENSIONS['User Status'], userStatus);
}

export function setDimensionsUserType(isPaid = false): void {
  const userType = isPaid ? 'Paid' : 'Organic';
  ReactGA.ga('set', DIMENSIONS['User Type'], userType);
}

export function setContentGroups(_groups: ContentGroups = {}): void {
  const groups = _groups;

  // Content groups that are not included should be set to null, this is to ensure that any
  // previously set groups are not unintentionally included in subsequent events. The only
  // way to unset a content group is to set it's value to null (no official documentation but it works)
  Object.keys(CONTENT_GROUPS).forEach((key) => {
    if (!groups[key]) {
      groups[key] = null;
    }
  });
  Object.keys(groups).forEach((key) => {
    ReactGA.ga('set', CONTENT_GROUPS[key], groups[key]);
  });
}

export function isPaidParam(paidParam?: string | string[]): boolean {
  return paidParam ? paidParam !== 'f' && paidParam !== '0' : false;
}

export default new GoogleAnalytics();
